import {
  ConversationMessage,
  ConversationMessageRoleEnum,
  ToolApprovalStatusEnum,
  ToolApprovalTypeEnum,
  ToolUse,
  ToolUseTypeEnum,
} from "src/clients/copilot";

export const pendingToolUseRequestMessage = (
  messages: ConversationMessage[],
): ToolUse | null => {
  if (messages.length === 0) return null;

  const lastMessage = messages[messages.length - 1];
  if (
    lastMessage.role === ConversationMessageRoleEnum.COPILOT &&
    lastMessage.tool_use &&
    lastMessage.tool_use.type === ToolUseTypeEnum.REQUEST
  ) {
    return lastMessage.tool_use;
  }

  return null;
};

export const createToolApprovalMessage = (
  toolUse: ToolUse,
  approved: boolean,
): ConversationMessage => ({
  role: ConversationMessageRoleEnum.USER,
  content: approved ? "approved" : "denied",
  tool_use: {
    type: ToolApprovalTypeEnum.APPROVAL,
    tool_use_id: toolUse.tool_use_id,
    tool_name: toolUse.tool_name,
    tool_input: toolUse.tool_input,
    status: approved
      ? ToolApprovalStatusEnum.APPROVED
      : ToolApprovalStatusEnum.DENIED,
    content: "",
  } as unknown as ToolUse,
});
